import type { LiveResumo, Semaforo } from '@/api/painel';
import { StatusLight } from './Kpi';
import { fmtInt } from './format';

const ORDEM: Semaforo[] = ['verde', 'amarelo', 'vermelho'];

/**
 * "N conectados de M" + um card por semáforo com a divisão AC/DC (cards de
 * status da Tupi). Semáforo sempre com forma + texto, nunca só a cor.
 */
export function StatusSummary({ resumo, hubDisponivel }: { resumo: LiveResumo; hubDisponivel: boolean }) {
  const por = new Map(resumo.por_semaforo.map((c) => [c.semaforo, c]));
  return (
    <div>
      <p className="m-0 text-[14px] text-bow-royal">
        {resumo.conectados == null || !hubDisponivel ? (
          <>
            <span className="font-semibold">{fmtInt(resumo.carregadores)}</span> carregadores · central de
            comunicação instável, sem leitura agora
          </>
        ) : (
          <>
            <span className="text-[22px] font-semibold tracking-[-0.02em]">{fmtInt(resumo.conectados)}</span>
            <span className="text-bow-royal/60"> conectados de {fmtInt(resumo.carregadores)}</span>
          </>
        )}
      </p>
      <div className="mt-3 grid grid-cols-3 gap-2">
        {ORDEM.map((s) => {
          const c = por.get(s) ?? { semaforo: s, ac: 0, dc: 0 };
          return (
            <div key={s} className="rounded-2xl bg-bow-cream/60 px-3 py-2.5">
              <StatusLight value={s} />
              <div className="mt-1 text-[20px] font-semibold tabular-nums leading-none text-bow-royal">
                {fmtInt(c.ac + c.dc)}
              </div>
              <div className="mt-1 text-[11.5px] tabular-nums text-bow-royal/55">
                AC {fmtInt(c.ac)} · DC {fmtInt(c.dc)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
